import React from "react";
import { ReactComponent as Cross } from "../../assets/icons/Cross.svg";
import { ReactComponent as Edit } from "../../assets/icons/edit.svg";
import { ReactComponent as Clipboard } from "../../assets/icons/clipboard-empty.svg";
import { ReactComponent as Delete } from "../../assets/icons/delete.svg";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import { urls } from "../../Utils/url";
import { toast } from "react-toastify";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

export const removeBill = (number, token, setBills, companyId, bills) => {
  ApiCall(
    "delete",
    `${urls.DeleteUserBill}${number}`,
    null,
    "DeleteBills",
    token,
    function(e) {
      setBills(bills.filter(i => i.id !== number));
    }
  );
};

export const editBill = (title, token, selectedBillId, bills, setBills) => {
  ApiCall(
    "put",
    `${urls.UpdateBillParam}${selectedBillId}?title=${title}`,
    null,
    "DeleteBills",
    token,
    function(e) {
      toast.success("عملیات با موفقیت انجام شد.", {
        position: "bottom-center"
      });
      setBills(
        bills.map(i => {
          if (i.id !== selectedBillId) return i;
          else return { ...i, title: title };
        })
      );
    }
  );
};

export const Module = ({ onClickYes, onClickNo }) => {
  return (
    <div className="DeleteBillModule">
      <div>
        <Delete fill={"red"} />
        <span>آیا از حذف این شناسه مطمئن هستید؟</span>
        <div>
          <div onClick={onClickNo}>خیر</div>
          <div onClick={onClickYes}>بله</div>
        </div>
      </div>
    </div>
  );
};
export const EditModule = ({ onClickYes, onClickNo, value, setBillTitle }) => {
  return (
    <div className="DeleteBillModule">
      <div>
        <Clipboard />
        <span>عنوان دلخواه را برای این شناسه انتخاب نمایید</span>
        <input
          className="textInputEdit"
          autoComplete={"off"}
          id="phone"
          value={value}
          placeholder="مثال: منزل یا محل کار"
          onChange={v => setBillTitle(v.target.value)}
        />
        <div>
          <div onClick={onClickNo}>لغو</div>
          <div onClick={onClickYes}>ثبت</div>
        </div>
      </div>
    </div>
  );
};

const BillComponent = ({
  data,
  onClick,
  identication,
  setModuleVisible,
  setModuleID,
  setEditModuleVisible,
  setSelectedBillId,
  usage
}) => {
  return (
    <div className="BillsComponent">
      <div
        className={
          !usage
            ? "BillsComponentDiv"
            : "BillsComponentDiv BillsComponentDivUsage"
        }
        onClick={onClick}
      >
        <span>{data.parameter}</span>
        <span style={usage && { marginRight: 30 }}>{data.title}</span>
      </div>
      {!usage && (
        <div>
          <div
            onClick={() => {
              setEditModuleVisible(true);
              setSelectedBillId(data.id);
            }}
          >
            <Edit />
            <span>ویرایش</span>
          </div>
          <div
            onClick={() => {
              setModuleVisible(true);
              setModuleID(identication);
            }}
          >
            <Cross />
            <span>حذف</span>
          </div>
        </div>
      )}
    </div>
  );
};

export const Bills = ({
  bills,
  onClick,
  setModuleVisible,
  onClickName,
  setModuleID,
  usage,
  setEditModuleVisible,
  setSelectedBillId,
  billsLoading
}) => {
  return (
    <div className={!usage ? "billsHistory" : "billsHistory billsHistoryUsage"}>
      {bills.length > 0 &&
        bills.map((i, index) => (
          <BillComponent
            setSelectedBillId={setSelectedBillId}
            setModuleVisible={setModuleVisible}
            setEditModuleVisible={setEditModuleVisible}
            setModuleID={setModuleID}
            data={i}
            usage={usage}
            identication={i.id}
            key={`#Bill${i.parameter}${index}`}
            onClick={() => {
              onClick(!usage ? i.parameter : i.bill_id);
              onClickName(i.title);
            }}
          />
        ))}
      {bills.length === 0 && !usage && !billsLoading && (
        <h5>
          تا کنون قبضی پرداخت نکرده اید. شناسه قبض های پرداخت شده در اینجا نشان
          داده خواهد شد
        </h5>
      )}
      {bills.length === 0 && !usage && billsLoading && (
        <div className="BillsLoading">
          <Loader type="Rings" color={"#2c3e50"} />
        </div>
      )}
    </div>
  );
};

export default Bills;
